import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-footer-link',
  standalone: false,
  templateUrl: './footer-link.component.html',
  styleUrl: './footer-link.component.scss'
})
export class FooterLinkComponent {

  @Input() isWhiteText: boolean = false;

  openPrivacyChoices(event: Event) {
    event.preventDefault();
    if (window._iub && window._iub.cs && window._iub.cs.api) {
      window._iub.cs.api.openPreferences();
    }
  }
  
}
